import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'
import useRouteParser from 'src/hooks/routeParser'

const { t } = useI18n()
const { getPaginationCasts, getPaginationInject } = useRouteParser()

const module: RouteRecordRawArgumented = {
  path: 'warehouses-refilling-levels',
  name: 'warehousesRefillingLevels',
  component: () =>
    import(
      /* webpackChunkName: "warehouses-refilling-levels" */ 'pages/order-bot/WarehouseRefillingLevels.vue'
    ),
  meta: {
    breadcrumb: {
      name: t('breadcrumb.order_bot.warehouses_refilling_levels'),
      icon: 'mdi-format-wrap-square',
    },
    auth: {
      permission: 'order_bot_manage',
    },
    inject: {
      query: {
        ...getPaginationInject(),
        sort: 'created_at',
        dir: 'desc',
      },
    },
    casts: {
      query: {
        ...getPaginationCasts(),
      },
    },
  },
  children: [
    {
      path: 'upload-refilling-levels',
      name: 'warehouseRefillingUploadLevels',
      component: () =>
        import(
          /* webpackChunkName: "warehouse-refilling-upload-levels" */ 'pages/order-bot/WarehouseRefillingUploadLevels.vue'
        ),
      meta: {
        breadcrumb: {
          icon: 'mdi-traffic-light',
          name: t(
            'breadcrumb.order_bot.create_forcing_distribution_project_massive'
          ),
        },
        auth: {
          permission: 'order_bot_manage',
        },
        casts: {
          query: {},
        },
      },
    },
  ],
}

export default module
